























import { Component, Vue } from 'vue-property-decorator';
import VueBase from '@/VueBase.vue';
import { ICart } from '@/models/CartModels';

@Component({})
export default class CartAdd extends VueBase {
  public title: string = '';

  public async createCart() {
    const cart: ICart = {
      title: this.title,
      items: [],
    };
    const success = await this.$store.dispatch('carts/add', cart);

    if (success) {
      this.$router.push({ name: 'viewCart', params: { id: cart.title } });
    }
  }
}
